import { render, staticRenderFns } from "./PromoCouponList.vue?vue&type=template&id=08eca735&scoped=true&"
import script from "./PromoCouponList.vue?vue&type=script&lang=js&"
export * from "./PromoCouponList.vue?vue&type=script&lang=js&"
import style0 from "./PromoCouponList.vue?vue&type=style&index=0&id=08eca735&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08eca735",
  null
  
)

export default component.exports